import { render, staticRenderFns } from "./PedidoViewComponent.vue?vue&type=template&id=7fdb2fab&"
import script from "./PedidoViewComponent.vue?vue&type=script&lang=js&"
export * from "./PedidoViewComponent.vue?vue&type=script&lang=js&"
import style0 from "./PedidoViewComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports